<template></template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { onBeforeMount, ref } from "vue";
import _ from "lodash";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

// http://localhost:5173/cc-onboard/webform/apply/sendBack/request?webFormRequestId=75efaf37-b401-44e8-a989-32b1679b86d0

const router = useRouter();

const webFormRequestId = ref<string>("");

const parseQueryString = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("webFormRequestId") || "";
};

onBeforeMount(() => {
  webFormRequestId.value = parseQueryString();
  if (webFormRequestId.value == "" || null) {
    router.push({
      name: "Acknowledgement",
      query: {
        status: "invalidLink",
      },
    });
  } else {
    MasterService.sendBackValidate(webFormRequestId.value)
      .then((res) => {
        if (res.status == 200) {
          if (res.data.responseModel.status == "INIT") {
            router.push({
              name: "SendBack",
              state: { responseModel: res.data.responseModel },
              query: { webFormRequestId: webFormRequestId.value },
            });
          } else if (res.data.responseModel.status == "SUBMITTED") {
            router.push({
              name: "Acknowledgement",
              query: {
                status: "sendBack",
                refNo: res.data.responseModel.refNo,
              },
            });
          } else {
            router.push({
              name: "Acknowledgement",
              query: {
                status: "expired",
                refNo: res.data.responseModel.refNo,
              },
            });
          }
        }
      })
      .catch((e) => {
        router.push({
          name: "Acknowledgement",
          query: {
            status: "expired",
          },
        });
      });
  }
});
</script>

<style scoped></style>
